import React from 'react';
import { IIconProps } from './utils';

export const CaretClosed = ({
  fill = 'currentColor', width = 12, ...rest
}: IIconProps) => {
  const widthInt = typeof width === 'string' ? parseInt(width, 10) : width;

  return (
    <svg
      fill="none"
      height={widthInt / 2}
      viewBox="0 0 12 6"
      width={widthInt}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12 0 H0 L6 6 L12 0 Z"
        fill={fill}
      />
    </svg>
  );
};
